<template>
  <section class="employers-lt-agents  container">
    <div class="employers-lt-agents__content  container-inner">
      <h2 class="employers-lt-agents__title">{{ section.title }}</h2>
      <div :class="{'_center': computedCenter}"
           class="employers-lt-agents__list">
        <EmployersLTPageAgentsCard v-for="item in itemsComputed"
                                   :key="item.id"
                                   :review="item"
                                   class="employers-lt-agents__item"/>
      </div>

      <slot name="btn">
        <EmployersLTPageGetHelpBtn :text="section.button"
                                   class="employers-lt-agents__btn"/>
      </slot>
    </div>
  </section>
</template>

<script>
  import {WINDOW_SIZE_LG} from '@/constants/windowSizes'
  import windowSizeMixin from '@/mixins/windowSizeMixin'
  import EmployersLTPageGetHelpBtn from '@/components/employersLTPage/common/EmployersLTPageGetHelpBtn'
  import EmployersLTPageAgentsCard from '@/components/employersLTPage/EmployersLTPageAgentsCard'

  export default {
    name: 'EmployersLTPageAgents',
    mixins: [windowSizeMixin],
    components: {
      EmployersLTPageGetHelpBtn,
      EmployersLTPageAgentsCard
    },
    props: {
      section: Object,
    },
    data() {
      return {
        WINDOW_SIZE_LG
      }
    },
    computed: {
      itemsComputed() {
        return this.windowSizeMixin.width <= WINDOW_SIZE_LG ? this.section.items.data.slice(0, 3) : this.section.items.data.slice(0, 4)
      },
      computedCenter() {
        return this.itemsComputed.length < 3 || this.windowSizeMixin.width > WINDOW_SIZE_LG && this.itemsComputed.length < 4
      },
    }
  }
</script>

<style lang="less">

</style>
